module.exports = __webpack_public_path__ + "img/Danyang_Liu.b4b3090c.png";